"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeriesNonceManagerFacade = void 0;
const tslib_1 = require("tslib");
const series_nonce_manager_const_1 = require("./series-nonce-manager.const");
const series_nonce_manager_model_1 = require("./model/series-nonce-manager.model");
const abstract_facade_1 = require("./utils/abstract-facade");
class SeriesNonceManagerFacade extends abstract_facade_1.AbstractSmartcontractFacade {
    constructor() {
        super(...arguments);
        this.ABI = series_nonce_manager_const_1.SERIES_NONCE_MANAGER_ABI;
        this.advanceNonce = (series, count) => {
            return this.getContractCallData(series_nonce_manager_model_1.SeriesNonceManagerMethods.advanceNonce, [series, count]);
        };
    }
    getNonce(series, makerAddress) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const callData = this.getContractCallData(series_nonce_manager_model_1.SeriesNonceManagerMethods.nonce, [
                series,
                makerAddress,
            ]);
            return this.providerConnector
                .ethCall(this.contractAddress, callData)
                .then((nonce) => BigInt(nonce));
        });
    }
    increaseNonce(series) {
        return this.getContractCallData(series_nonce_manager_model_1.SeriesNonceManagerMethods.increaseNonce, [series]);
    }
}
exports.SeriesNonceManagerFacade = SeriesNonceManagerFacade;
//# sourceMappingURL=series-nonce-manager.facade.js.map